import {memo} from 'react'

import {restApi} from '../../../../services/rest'
import type {BuildId, ProjectId} from '../../../../types'
import {useSequenceLoaderReadyHandler} from '../../../common/SequenceLoader/SequenceLoader.hooks'

import ProblemsTree from './BuildProblemsTree'
import {useBuildProblemsTreeArg} from './BuildProblemsTree.hooks'

type Props = {
  labelId: string
  className?: string
  projectId?: ProjectId
  buildId?: BuildId
  locator: string
}

function ProblemsTreeWrapper(props: Props) {
  const {locator} = props

  const arg = useBuildProblemsTreeArg(locator)
  const {noLeaves, ready} = restApi.endpoints.getProblemOccurrenceTree.useQuery(arg, {
    selectFromResult: ({data}) => ({noLeaves: data?.tree.leaf?.length === 0, ready: data != null}),
  })

  useSequenceLoaderReadyHandler(ready)

  if (noLeaves || !ready) {
    return null
  }

  return <ProblemsTree {...props} />
}

export default memo<Props>(ProblemsTreeWrapper)
